module.exports = {
      id: "qt-logo-usage",
      viewBox: "0 0 32 32",
      url: "/" + "sprite-830c6fc89c6e575b53718d760c90aee8.svg#qt-logo",
      toString: function () {
        return this.url;
      }
    }